// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fortawesome/fontawesome-free/css/all.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Theme Variables */
.ftthsa {
  --white: #ffffff;
  --black: #000000;
  --primary1: #0f174f;
  --secondary: #e65c1c;
  --text-color: #333333;
  --background-color: #f9f9f9;
}

/* Utility Classes Using the Theme */
.bg-primary {
  background-color: var(--primary1);
}

.bg-secondary {
  background-color: var(--secondary);
}

.text-white {
  color: var(--white);
}

.text-black {
  color: var(--black);
}

.text-primary {
  color: var(--primary);
}

.text-secondary {
  color: var(--secondary);
}

.btn-primary {
  background-color: var(--primary);
  color: var(--white);
  border: none;
  padding: 10px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.btn-primary:hover {
  background-color: #0a123a; /* darker shade of primary */
}

.btn-secondary {
  background-color: var(--secondary);
  color: var(--white);
  border: none;
  padding: 10px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.btn-secondary:hover {
  background-color: #e2520f; /* darker shade of secondary */
}

.full-width-block {
  width: 100%;
  background-color: #e2520f;
  text-align: center;
  color: #fff;
  padding: 5px;
  box-sizing: border-box;
  margin-top: 0px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);/* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it overlays everything */
}

.spinner-border {
  width: 3rem;
  height: 3rem;
  color: #ffffff;
}

/* -------- Navbar CSS Start -------- */

/* Navbar background */
/* .orange-block {
  background-color: #ec4d13;
  height: 50px;
} */

/* Navbar container */
.navbar .container-fluid {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap; /* Prevent wrapping */
  padding: 0.5rem 1rem;
}

/* Logo */
.navbar-brand img {
  height: 20px; /* Default logo size */
}

/* Navbar links wrapper */
.custom-navbar-links {
  display: flex;
  flex: 1 1; /* Allow navbar links to take available space */
  justify-content: end;
}

/* Ensure navbar items are in a row */
.navbar-nav {
  display: flex !important; /* Ensure Bootstrap does not override */
  flex-direction: row !important; /* Force horizontal alignment */
  align-items: center;
  gap: 20px;
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Navbar links */
.navbar-nav .nav-item {
  display: flex; /* Ensure links don't stack */
  align-items: center;
}

/* Navbar link styles */
.navbar-nav .nav-link {
  padding: 8px 12px;
  color: #0f174f;
  text-decoration: none;
  font-size: 14px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* Icons inside links */
.navbar-nav .nav-link i {
  font-size: 16px;
}

/* Login button */
.btn-theme-orange {
  background-color: #e2520f;
  border: none;
  border-radius: 5px;
  color: white;
  padding: 8px 14px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

/* Adjustments for small screens */
@media (max-width: 768px) {
  .navbar-brand img {
    height: 15px; /* Smaller logo size for small devices */
  }

  .btn-theme-orange {
    font-size: 10px;
    padding: 6px 10px;
  }

  .custom-navbar-links {
    gap: 1px;
  }

  .navbar-nav {
    gap: 1px;
  }

}
/* -------- Navbar CSS End -------- */






/* --------FIBRE CSS START-------- */



.content1 {
  display: flex;
  justify-content: space-evenly;
  align-items: stretch;
  flex-wrap: nowrap; /* prevent wrapping on larger screens */
  width: 100%;
  /* padding: 48px; */
  padding-bottom: 40px;
  gap: 10px; /* some spacing between cards */
  overflow-x: auto; /* fallback scroll if too many cards */
}

.custom-card {
  flex: 1 1; /* allow shrinking */
  min-width: 220px; /* don’t shrink too small */
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
  padding-bottom: 10px;
  margin: 20px;
  margin-left: 0px;
}

/* Mobile view → stack vertically */
@media (max-width: 568px) {
  .content1 {
    flex-direction: column;
    flex-wrap: nowrap; /* stack, don’t wrap horizontally */
    align-items: center;
  }

  .custom-card {
    width: 100%; /* take most of the screen */
    max-width: none;
    align-items: center;
  }
}


.custom-card-header {
  background-color: #E2520F;
  color: white;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  padding: 10px;
  border-radius: 20px 20px 0 0;
  width: 100%;
}

.custom-card-body {
  padding: 15px;
  text-align: center;
}

.custom-card-footer {
  margin-top: auto;
  display: flex; /* Enable Flexbox */
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically (optional) */
  
}

.text-orange {
  color: #E2520F;
}

.btn-orange {
  background-color: #E2520F;
  color: #ffffff;
  border: none;
  border-radius: 35px;
  padding: 10px 50px;
  font-size: 0.7rem;
  font-weight: bold;
  transition: all 0.3s ease;
  width: 100%;
  margin: 0 auto;
  display: block;
}

.btn-orange:hover {
  background-color: #0f174f;
}
/* --------FIBRE CSS END-------- */





/*----------RFC CSS START----------- */

.btn-custom {
  background-color: #131d72;
  color: #ffffff;
  border: none;
  border-radius: 35px;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 45px;
  width: 177px;
}

.btn-custom:hover {
  background-color: #0f174f; /* Slightly darker shade on hover */
  transform: scale(1.05); /* Zoom effect */
}

/* ----------RFC CSS END------------- */








/* -------- ABOUT US CSS START -------- */
.container {
  max-width: 1200px;
  margin: auto; /* Center the container */
}

h2 {
  font-size: 2rem; /* Increase the font size */
  margin-bottom: 2rem;
  color: rgb(23 37 84); /* Apply text-blue-950 color */
  text-transform: uppercase; /* Optional: Makes text uppercase */
  text-align: center; /* Center align */
}

h4 {
  font-size: 1.5rem; /* Increase the font size */
  font-weight: bold;
  color: rgb(23 37 84); /* Apply text-blue-950 color */
  margin: 12px 25px
}

p2 {
  font-size: 1.125rem; /* Increase the font size */
  line-height: 1.8; /* Adjust line spacing */
  color: #000; /* Light gray color */
  font-weight: 500;
  margin: 12px 125px
}

/* Add optional padding for better spacing */
.mb-4 {
  margin-bottom: 1.5rem !important;
}


.about-block {
  background-color: #ffffff; /* White background */
  border-radius: 8px; /* Rounded corners */
  padding: 20px;/* Padding inside the block */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  transition: box-shadow 0.3s ease, transform 0.3s ease; /* Smooth hover effect */
  margin: 40px;
}

/* Hover effect */
.about-block:hover {
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.2); /* Stronger shadow on hover */
  transform: translateY(-5px); /* Slight upward movement */
}

/* Paragraph styling */
.about-block p {
  color: rgb(23, 37, 84); /* Text color */
  font-size: 1rem; /* Font size */
  line-height: 1.5; /* Line height for readability */
}


/* -------- ABOUT US CSS END ----------- */







/* --------- FOOTER CSS START ----------- */

.footer {
  background-color: #e65c1c;
  color: white;
  text-align: center;
  padding: 10px 0;
}

/* Stick Footer to Bottom on Larger Screens */
@media (min-width: 768px) {
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .main-content {
    padding-bottom: 60px; /* Add space for the footer */
  }
}

/* --------- FOOTER CSS END ------------ */










/*------ APPLICATION FORM CSS START ------  */


#application-form-page {
  background: #fff;
  padding: 10px;
  /* border: 1px solid #ccc;
  border-radius: 5px; */
}

#application-form-page label {
  font-weight: bold;
  margin-top: 10px;
}

#application-form-page input,
#application-form-page textarea,
#application-form-page select {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s ease; /* Smooth transition for border color */
}

#application-form-page input:focus,
#application-form-page textarea:focus,
#application-form-page select:focus,
#application-form-page input:hover,
#application-form-page textarea:hover,
#application-form-page select:hover {
  border-color: #e56521; /* Orange border on focus and hover */
  outline: none; /* Remove default outline */
}

#application-form-page .btn {
  font-weight: bold;
  padding: 10px 15px;
  background-color: #e56521;
  border: none;
  color: #ffffff;
}
#application-form-page .btn:hover {
  background-color: #131d72; /* Darker orange on hover */
}

#application-form-page h2,
#application-form-page h4 {
  color: #e56521;
  font-weight: bold;
}

#application-form-page .form-section {
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 20px;
  background-color: #fff;
}




/* ------- APPLICATION FORM CSS END ------- */













/* ------- PROFILE CSS START --------- */

.group {
  max-width: 1070px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 2px;
}

.group,
.group2 {
  min-width: 300px;
  padding: 17px;
}

.group2 {
  max-width: 1091px;
}

/* ------- PROFILE CSS END ---------- */



/* --------- MANAGE SUBSCRIPTION CSS START */

.btn-action {
  background-color: #E2520F; /* Orange color */
  color: #ffffff; /* White text */
  border: none; /* Remove default border */
  border-radius: 10px; /* Rounded corners */
  padding: 10px 20px; /* Padding for the button */
  font-size: 0.7rem; /* Font size */
  font-weight: bold; /* Bold text */
  cursor: pointer; /* Change cursor to pointer on hover */
  transition: all 0.3s ease; /* Smooth transition for hover effects */
}

.btn-action:hover {
  background-color: #152455; /* Darker orange on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow on hover */
}

/* --------- MANAGE SUBSCRIPTION CSS START */





/* --------- MANAGE PACKAGE CSS START */

.container {
  max-width: 600px;
  margin: auto;
}

.card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
}

/* .btn-orange {
  background-color: #E2520F;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 0.9rem;
  font-weight: bold;
  transition: all 0.3s ease;
} */

/* .btn-orange:hover {
  background-color: #E63900;
} */

.btn-outline-orange {
  background-color: transparent;
  color: #E2520F;
  border: 2px solid #E2520F;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 0.9rem;
  font-weight: bold;
  transition: all 0.3s ease;
}

.btn-outline-orange:hover {
  background-color: #E2520F;
  color: #fff;
}


/* --------- MANAGE PACKAGE CSS END ----------------*/







/* ------------------- logged in nav -----------------*/

/* Navbar background */
.loggedin-nav-background {
  background-color: #e2520f;
  height: 50px;
}

/* Navbar container */
.loggedin-nav-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap; /* Prevent wrapping */
  padding: 0.5rem 1rem;
}

/* Logo */
.loggedin-nav-logo img {
  height: 20px; /* Default logo size */
}

/* Navbar links wrapper */
.loggedin-nav-links {
  display: flex;
  flex: 1 1; /* Allow navbar links to take available space */
  justify-content: end;
}

/* Ensure navbar items are in a row */
.loggedin-nav-items {
  display: flex;
  flex-direction: row; /* Horizontal layout for all screen sizes */
  align-items: center;
  gap: 20px;
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Navbar links */
.loggedin-nav-item {
  display: flex; /* Ensure links don't stack */
  align-items: center;
}

/* Navbar link styles */
.loggedin-nav-link {
  padding: 8px 12px;
  color: #0f174f;
  text-decoration: none;
  font-size: 14px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* Icons inside links */
.loggedin-nav-link i {
  font-size: 16px;
}

/* Login button */
.loggedin-nav-btn {
  background-color: #e2520f;
  border: none;
  border-radius: 5px;
  color: white;
  padding: 8px 14px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

/* Adjustments for small screens */
@media (max-width: 768px) {
  .loggedin-nav-items {
    flex-direction: row; /* Keep links horizontal */
    align-items: center; /* Center links vertically */
    gap: 10px; /* Add spacing between links */
  }

  .loggedin-nav-container {
    flex-direction: row; /* Keep the container horizontal */
    align-items: center;
    justify-content: space-between; /* Space out items */
  }

  .loggedin-nav-links {
    width: auto; /* Allow links to take their natural width */
  }

  .loggedin-nav-link {
    width: auto; /* Ensure links don't stretch */
    text-align: center; /* Center align text */
    padding: 8px 12px; /* Adjust padding for smaller screens */
  }
}

/* ------------------- logged in nav ----------------*/





/* ----------------------- Referral ------------------------ */
/* =========================
   REFERRAL PAGE
========================= */
/* =========================
   REFERRAL PAGE
========================= */

.referral-page {
  background: #f8fafc;
  min-height: 100vh;
}

/* =========================
   HERO SECTION
========================= */
/* =========================
   REFERRAL PAGE
========================= */

.referral-page {
  background: #f8fafc;
  min-height: 100vh;
}

/* =========================
   HERO SECTION
========================= */
.referral-hero {
  /* background image is set inline via style={{ backgroundImage: "url(/NEW.jpeg)" }} */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0;
  color: white;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
 min-height: clamp(290px, 49vw, 959px); 
  width: 100%;
}

.referral-hero .container {
  width: 100%;
  padding: clamp(20px, 6vw, 90px);
  box-sizing: border-box;
}

.referral-text-box {
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  padding: clamp(20px, 4vw, 32px) clamp(20px, 5vw, 40px);
  max-width: 680px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
}

.referral-title {
  color: #111111;
  font-size: clamp(1.25rem, 4vw, 2rem);
  line-height: 1.2;
}

.referral-subtitle {
  color: #444444;
  opacity: 1;
  font-size: clamp(0.875rem, 2.5vw, 1.05rem);
}

/* Tablet */
@media (max-width: 768px) {
  .referral-hero {
   min-height: 0px; 
  }

  .referral-text-box {
    border-radius: 12px 12px 0 0;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .referral-hero {
    min-height: 201px;
  }

  .referral-hero .container {
    padding: 16px;
  }

  .referral-text-box {
    border-radius: 10px 10px 0 0;
    box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.15);
  }
}

/* Very small screens */
@media (max-width: 360px) {
  .referral-hero {
    min-height: 16px;
  }

  .referral-text-box {
    padding: 16px;
  }
}


/* 



 =========================
   BENEFITS SECTION
========================= */

.referral-benefits {
  padding: 70px 20px;
}

.benefit-card {
  border: none !important;
  border-radius: 18px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  transition: all 0.25s ease;
  overflow: hidden;
}

.benefit-card:hover {
  transform: translateY(-6px);
}

.benefit-card .card-body {
  padding: 35px 25px;
  text-align: center;
}

.benefit-card h4 {
  color: #0f174f;
  font-weight: 700;
  margin-bottom: 14px;
}

.benefit-card p {
  color: #6b7280;
  margin-bottom: 0;
  line-height: 1.6;
}

.benefit-icon {
  width: 70px;
  height: 70px;
  border-radius: 16px;
  background: rgba(226, 82, 15, 0.1);
  color: #e2520f;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  font-size: 2rem;
}

/* =========================
   FORM SECTION
========================= */

.referral-form-section {
  padding: 90px 20px 90px 20px;
}

.referral-form-card {
  border: none !important;
  border-radius: 22px !important;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(15, 23, 79, 0.08);
}

.referral-form-card .card-body {
  padding: 45px;
}

.rf-card {
  border: none !important;
  border-radius: 22px !important;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(15, 23, 79, 0.08);
  background: #ffffff;
}

.rf-card .card-body {
  padding: 45px;
}

.rf-section {
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 18px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.rf-section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.rf-label-plain,
.rf-step-title {
  font-size: 0.76rem;
  letter-spacing: 0.08em;
  font-weight: 800;
  color: #0f174f;
}

.rf-step-num {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background: #e2520f;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
}

.rf-section-line {
  flex: 1 1;
  height: 1px;
  background: linear-gradient(90deg, rgba(226, 82, 15, 0.35), rgba(226, 82, 15, 0.05));
}

.rf-section-end-icon {
  color: #e2520f;
  font-size: 1rem;
}

.rf-grid {
  display: grid;
  gap: 1rem;
}

.rf-grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.rf-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.rf-field-full {
  grid-column: 1 / -1;
}

.rf-field-label {
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  font-weight: 700;
  color: #374151;
}

.rf-input-wrap {
  position: relative;
}

.rf-input-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 1rem;
}

.rf-input {
  width: 100%;
  min-height: 52px;
  border-radius: 14px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  padding: 0.9rem 1rem 0.9rem 2.75rem;
  color: #111827;
  font-size: 0.98rem;
  transition: all 0.2s ease;
}

.rf-input::placeholder {
  color: #9ca3af;
}

.rf-input:focus {
  border-color: #e2520f !important;
  box-shadow: 0 0 0 0.2rem rgba(226, 82, 15, 0.15) !important;
  outline: none;
}

.rf-input-readonly {
  background: #f3f4f6;
  color: #374151;
  cursor: default;
}

.rf-credit-note {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(226, 82, 15, 0.12);
  background: rgba(226, 82, 15, 0.04);
  color: #4b5563;
  font-size: 0.9rem;
  line-height: 1.5;
}

.rf-credit-note i {
  color: #e2520f;
  margin-top: 0.15rem;
}

.rf-credit-note a,
.rf-reward-note a {
  color: #e2520f;
  font-weight: 600;
  text-decoration: none;
}

.rf-consent {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1rem 1.1rem;
  border-radius: 14px;
  border: 1px solid #edf1f6;
  background: #f8fafc;
  color: #374151;
  line-height: 1.5;
}

.rf-consent input {
  margin-top: 0.2rem;
  width: 1.05rem;
  height: 1.05rem;
  accent-color: #e2520f;
}

.rf-footer {
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.rf-reward-note {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  color: #4b5563;
  line-height: 1.5;
  font-size: 0.95rem;
}

.rf-reward-icon {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: rgba(226, 82, 15, 0.12);
  color: #e2520f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rf-submit-btn {
  background: #e2520f !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 0.95rem 2rem !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  box-shadow: 0 10px 20px rgba(226, 82, 15, 0.2);
  transition: all 0.25s ease;
}

.rf-submit-btn:hover {
  background: #c9470d !important;
  transform: translateY(-1px);
}

.rf-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  box-shadow: none;
}

.rf-submit-icon {
  font-size: 1rem;
}

.rf-locked-card {
  background: #ffffff;
}

.rf-locked-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 50px 2rem !important;
}

.rf-locked-icon {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  background: rgba(226, 82, 15, 0.1);
  color: #e2520f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  margin-bottom: 1.1rem;
}

.rf-locked-text {
  max-width: 540px;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.rf-success-modal-body {
  text-align: center;
  padding: 2rem 1.5rem;
}

.rf-success-icon {
  font-size: 3rem;
  color: #2f9e44;
  margin-bottom: 0.75rem;
}

.rf-success-title {
  color: #0f174f;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.rf-success-text {
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.rf-success-code {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1rem;
  border-radius: 16px;
  border: 1px solid rgba(226, 82, 15, 0.15);
  background: rgba(226, 82, 15, 0.03);
}

.rf-success-code-label {
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: #6b7280;
}

.rf-success-code-value {
  font-size: 1.35rem;
  font-weight: 800;
  color: #e2520f;
}

.form-title {
  text-align: center;
  color: #0f174f;
  font-weight: 800;
  margin-bottom: 35px;
}

.section-title {
  color: #e2520f;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(226, 82, 15, 0.1);
}

/* =========================
   FORM INPUTS
========================= */

.form-label {
  font-weight: 600;
  color: #374151;
}

.form-control,
.form-select {
  border-radius: 12px !important;
  min-height: 50px;
  border: 1px solid #d1d5db !important;
  transition: all 0.2s ease;
}

.form-control:focus,
.form-select:focus {
  border-color: #e2520f !important;
  box-shadow: 0 0 0 0.2rem rgba(226, 82, 15, 0.15) !important;
}

/* =========================
   CHECKBOX
========================= */

.form-check-input:checked {
  background-color: #e2520f !important;
  border-color: #e2520f !important;
}

.form-check-label {
  color: #4b5563;
  line-height: 1.5;
}

/* =========================
   SUBMIT BUTTON
========================= */

.submit-referral-btn {
  background: #e2520f !important;
  border: none !important;
  padding: 14px 40px !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  transition: all 0.25s ease;
  min-width: 240px;
}

.submit-referral-btn:hover {
  background: #c9470d !important;
  transform: translateY(-2px);
}

.submit-referral-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* =========================
   ALERT
========================= */

.alert-success {
  border-radius: 14px !important;
  border: none !important;
  background: rgba(34, 197, 94, 0.12) !important;
  color: #15803d !important;
  font-weight: 600;
  padding: 16px 20px !important;
}

/* =========================
   RESPONSIVE
========================= */

@media (max-width: 768px) {
  .referral-hero {
    padding: 80px 20px;
  }

  .referral-form-card .card-body {
    padding: 28px 20px;
  }

  .referral-title {
    font-size: 2.2rem;
  }

  .submit-referral-btn {
    width: 100%;
  }

  .benefit-card .card-body {
    padding: 28px 20px;
  }
}

@media (max-width: 480px) {
  .referral-subtitle {
    font-size: 1rem;
  }

  .form-title {
    font-size: 1.6rem;
  }

  .section-title {
    font-size: 1.1rem;
  }
}









/* ===================================================================
   Referral Form — colors & type sizes matched to the approved mockup
   =================================================================== */

:root {
  --rf-navy: #0a1a3c;
  --rf-orange: #e65c1c;
  --rf-orange-bg: #fdf0e6;
  --rf-orange-border: #f5cca3;
  --rf-orange-text: #8a4a1f;
  --rf-green: #2e8b3d;
  --rf-green-bg: #e8f6ea;
  --rf-green-text: #1f6b34;
  --rf-gray-label: #6b7280;
  --rf-gray-input-bg: #f3f4f6;
  --rf-gray-border: #d9dce1;
  --rf-gray-icon: #9aa1ab;
  --rf-text: #374151;
  --rf-page-bg: #f5f6f8;
}

.referral-page {
  background: var(--rf-page-bg);
}

/* ---------- form card ---------- */

.referral-form-section {
  padding: 40px 0;
}

.rf-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(10, 26, 60, 0.06);
  padding: 12px;
  margin-bottom: 18%;
}

.form-title {
  color: var(--rf-navy);
  font-weight: 800;
  font-size: 26px;
  text-align: center;
  letter-spacing: 0.5px;
  margin-bottom: 28px;
}

/* ---------- section headers ---------- */

.rf-section {
  margin-bottom: 20px;
}

.rf-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.rf-label-plain {
  color: var(--rf-navy);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.rf-step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--rf-orange);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.rf-step-title {
  color: var(--rf-navy);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap;
}

.rf-section-line {
  flex: 1 1;
  height: 1px;
  background: var(--rf-orange-border);
}

.rf-section-end-icon {
  color: var(--rf-orange);
  font-size: 14px;
}

/* ---------- fields ---------- */

.rf-grid {
  display: grid;
  gap: 16px;
}

.rf-grid-2 {
  grid-template-columns: 1fr 1fr;
}

.rf-field-full {
  grid-column: 1 / -1;
}

.rf-field-label {
  display: block;
  color: var(--rf-gray-label);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.rf-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.rf-input-icon {
  position: absolute;
  left: 12px;
  color: var(--rf-gray-icon);
  font-size: 14px;
  pointer-events: none;
}

.rf-input {
  width: 100%;
  height: 42px;
  padding: 0 14px 0 36px;
  font-size: 14px;
  color: var(--rf-text);
  background: #fff;
  border: 1px solid var(--rf-gray-border);
  border-radius: 8px;
  outline: none;
  transition: border-color 0.15s ease;
}

.rf-input::placeholder {
  color: #a3a9b3;
}

.rf-input:focus {
  border-color: var(--rf-orange);
}

.rf-input-readonly {
  background: var(--rf-gray-input-bg);
  color: #4b5563;
  cursor: default;
}

/* ---------- note boxes ---------- */

.rf-credit-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: var(--rf-orange-bg);
  border: 1px solid var(--rf-orange-border);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--rf-orange-text);
}

.rf-credit-note i {
  color: var(--rf-orange);
  font-size: 14px;
  margin-top: 2px;
}

.rf-credit-note a {
  color: var(--rf-orange);
  font-weight: 700;
  text-decoration: underline;
}

/* ---------- consent ---------- */

.rf-consent {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: var(--rf-text);
  cursor: pointer;
}

.rf-consent input[type="checkbox"] {
  margin-top: 2px;
  width: 15px;
  height: 15px;
  accent-color: var(--rf-orange);
}

/* ---------- footer ---------- */

.rf-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  flex-wrap: wrap;
}

.rf-reward-note {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--rf-green-bg);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--rf-green-text);
  flex: 1 1;
  min-width: 260px;
}

.rf-reward-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--rf-green);
  color: #fff;
  font-size: 13px;
  flex-shrink: 0;
}

.rf-reward-note a {
  color: var(--rf-green-text);
  font-weight: 700;
  text-decoration: underline;
}

.rf-submit-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: var(--rf-orange);
  border: none;
  color: #fff;
  font-weight: 700;
  font-size: 13.5px;
  letter-spacing: 0.4px;
  padding: 12px 20px;
  border-radius: 8px;
  white-space: nowrap;
  transition: background 0.15s ease;
}

.rf-submit-btn:hover {
  background: #cf4f14;
}

.rf-submit-btn:disabled {
  background: #f0a878;
  cursor: not-allowed;
}

.rf-submit-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  font-size: 11px;
}

/* ---------- success modal ---------- */

.rf-success-modal-body {
  text-align: center;
  padding: 32px 24px;
}

.rf-success-icon {
  color: #2f9e44;
  font-size: 48px;
  margin-bottom: 12px;
}

.rf-success-title {
  color: var(--rf-orange);
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 8px;
}

.rf-success-text {
  color: var(--rf-text);
  font-size: 13.5px;
  margin-bottom: 16px;
}

.rf-success-code {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: var(--rf-gray-input-bg);
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 20px;
}

.rf-success-code-label {
  color: var(--rf-gray-label);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.rf-success-code-value {
  color: var(--rf-navy);
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
}

/* !important here overrides react-bootstrap's default .btn-primary
   (blue) classes that ship alongside this custom class on <Button>. */
.rf-success-close-btn {
  background: var(--rf-orange) !important;
  border-color: var(--rf-orange) !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 13.5px;
  padding: 10px 28px;
  border-radius: 8px;
  box-shadow: none !important;
}

.rf-success-close-btn:hover,
.rf-success-close-btn:focus,
.rf-success-close-btn:active {
  background: #cf4f14 !important;
  border-color: #cf4f14 !important;
}

/* ---------- responsive ---------- */

@media (max-width: 576px) {
  .rf-grid-2 {
    grid-template-columns: 1fr;
  }
  .rf-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .rf-submit-btn {
    justify-content: center;
  }
}

.modal-header{
  background-color: #e2520f;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAIA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,CAAC,sCAAsC;EAC3E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC,sBAAsB;AACtB;;;GAGG;;AAEH,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB,EAAE,qBAAqB;EACxC,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,YAAY,EAAE,sBAAsB;AACtC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAO,EAAE,+CAA+C;EACxD,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,wBAAwB,EAAE,uCAAuC;EACjE,8BAA8B,EAAE,+BAA+B;EAC/D,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa,EAAE,6BAA6B;EAC5C,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY,EAAE,wCAAwC;EACxD;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;AAEF;AACA,qCAAqC;;;;;;;AAOrC,oCAAoC;;;;AAIpC;EACE,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB,EAAE,uCAAuC;EAC1D,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,SAAS,EAAE,+BAA+B;EAC1C,gBAAgB,EAAE,sCAAsC;AAC1D;;AAEA;EACE,SAAO,EAAE,oBAAoB;EAC7B,gBAAgB,EAAE,2BAA2B;EAC7C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE;IACE,sBAAsB;IACtB,iBAAiB,EAAE,mCAAmC;IACtD,mBAAmB;EACrB;;EAEA;IACE,WAAW,EAAE,4BAA4B;IACzC,eAAe;IACf,mBAAmB;EACrB;AACF;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa,EAAE,mBAAmB;EAClC,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,iCAAiC;;AAExD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA,kCAAkC;;;;;;AAMlC,sCAAsC;;AAEtC;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,sBAAsB,EAAE,gBAAgB;AAC1C;;AAEA,uCAAuC;;;;;;;;;AASvC,yCAAyC;AACzC;EACE,iBAAiB;EACjB,YAAY,EAAE,yBAAyB;AACzC;;AAEA;EACE,eAAe,EAAE,2BAA2B;EAC5C,mBAAmB;EACnB,oBAAoB,EAAE,8BAA8B;EACpD,yBAAyB,EAAE,mCAAmC;EAC9D,kBAAkB,EAAE,iBAAiB;AACvC;;AAEA;EACE,iBAAiB,EAAE,2BAA2B;EAC9C,iBAAiB;EACjB,oBAAoB,EAAE,8BAA8B;EACpD;AACF;;AAEA;EACE,mBAAmB,EAAE,2BAA2B;EAChD,gBAAgB,EAAE,wBAAwB;EAC1C,WAAW,EAAE,qBAAqB;EAClC,gBAAgB;EAChB;AACF;;AAEA,4CAA4C;AAC5C;EACE,gCAAgC;AAClC;;;AAGA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB,EAAE,oBAAoB;EACxC,aAAa,CAAC,6BAA6B;EAC3C,0CAA0C,EAAE,kBAAkB;EAC9D,qDAAqD,EAAE,wBAAwB;EAC/E,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,2CAA2C,EAAE,6BAA6B;EAC1E,2BAA2B,EAAE,2BAA2B;AAC1D;;AAEA,sBAAsB;AACtB;EACE,sBAAsB,EAAE,eAAe;EACvC,eAAe,EAAE,cAAc;EAC/B,gBAAgB,EAAE,gCAAgC;AACpD;;;AAGA,0CAA0C;;;;;;;;AAQ1C,2CAA2C;;AAE3C;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,oBAAoB,EAAE,6BAA6B;EACrD;AACF;;AAEA,0CAA0C;;;;;;;;;;;AAW1C,6CAA6C;;;AAG7C;EACE,gBAAgB;EAChB,aAAa;EACb;uBACqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC,EAAE,uCAAuC;AAC7E;;AAEA;;;;;;EAME,qBAAqB,EAAE,qCAAqC;EAC5D,aAAa,EAAE,2BAA2B;AAC5C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;;;;AAKA,6CAA6C;;;;;;;;;;;;;;AAc7C,wCAAwC;;AAExC;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uCAAuC;;;;AAIvC,4CAA4C;;AAE5C;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,eAAe;EAC/B,YAAY,EAAE,0BAA0B;EACxC,mBAAmB,EAAE,oBAAoB;EACzC,kBAAkB,EAAE,2BAA2B;EAC/C,iBAAiB,EAAE,cAAc;EACjC,iBAAiB,EAAE,cAAc;EACjC,eAAe,EAAE,sCAAsC;EACvD,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,wCAAwC,EAAE,oBAAoB;AAChE;;AAEA,4CAA4C;;;;;;AAM5C,uCAAuC;;AAEvC;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;;;;;;GASG;;AAEH;;GAEG;;AAEH;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;AAGA,qDAAqD;;;;;;;;AAQrD,uDAAuD;;AAEvD,sBAAsB;AACtB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB,EAAE,qBAAqB;EACxC,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,YAAY,EAAE,sBAAsB;AACtC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAO,EAAE,+CAA+C;EACxD,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB,EAAE,2CAA2C;EAChE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa,EAAE,6BAA6B;EAC5C,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE;IACE,mBAAmB,EAAE,0BAA0B;IAC/C,mBAAmB,EAAE,4BAA4B;IACjD,SAAS,EAAE,8BAA8B;EAC3C;;EAEA;IACE,mBAAmB,EAAE,kCAAkC;IACvD,mBAAmB;IACnB,8BAA8B,EAAE,oBAAoB;EACtD;;EAEA;IACE,WAAW,EAAE,4CAA4C;EAC3D;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,kBAAkB,EAAE,sBAAsB;IAC1C,iBAAiB,EAAE,uCAAuC;EAC5D;AACF;;AAEA,sDAAsD;;;;;;AAMtD,8DAA8D;AAC9D;;2BAE2B;AAC3B;;2BAE2B;;AAE3B;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;2BAE2B;AAC3B;;2BAE2B;;AAE3B;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;2BAE2B;AAC3B;EACE,qFAAqF;EACrF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;CAC1B,qCAAqC;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,sDAAsD;EACtD,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE;GACC,eAAe;EAChB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,2CAA2C;EAC7C;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;;;;;;2BAM2B;;AAE3B;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2CAA2C;EAC3C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;2BAE2B;;AAE3B;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oFAAoF;AACtF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,2DAA2D;EAC3D,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;;2BAE2B;;AAE3B;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8CAA8C;EAC9C,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;2BAE2B;;AAE3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;;;;;;;;;AAUA;;wEAEwE;;AAExE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,oCAAoC;;AAEpC;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,0CAA0C;;AAE1C;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA,wCAAwC;;AAExC;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;sEACsE;AACtE;EACE,uCAAuC;EACvC,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,qCAAqC;;AAErC;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@import '@fortawesome/fontawesome-free/css/all.css';\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Theme Variables */\n.ftthsa {\n  --white: #ffffff;\n  --black: #000000;\n  --primary1: #0f174f;\n  --secondary: #e65c1c;\n  --text-color: #333333;\n  --background-color: #f9f9f9;\n}\n\n/* Utility Classes Using the Theme */\n.bg-primary {\n  background-color: var(--primary1);\n}\n\n.bg-secondary {\n  background-color: var(--secondary);\n}\n\n.text-white {\n  color: var(--white);\n}\n\n.text-black {\n  color: var(--black);\n}\n\n.text-primary {\n  color: var(--primary);\n}\n\n.text-secondary {\n  color: var(--secondary);\n}\n\n.btn-primary {\n  background-color: var(--primary);\n  color: var(--white);\n  border: none;\n  padding: 10px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s ease;\n}\n\n.btn-primary:hover {\n  background-color: #0a123a; /* darker shade of primary */\n}\n\n.btn-secondary {\n  background-color: var(--secondary);\n  color: var(--white);\n  border: none;\n  padding: 10px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s ease;\n}\n\n.btn-secondary:hover {\n  background-color: #e2520f; /* darker shade of secondary */\n}\n\n.full-width-block {\n  width: 100%;\n  background-color: #e2520f;\n  text-align: center;\n  color: #fff;\n  padding: 5px;\n  box-sizing: border-box;\n  margin-top: 0px;\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);/* Semi-transparent white background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999; /* Ensure it overlays everything */\n}\n\n.spinner-border {\n  width: 3rem;\n  height: 3rem;\n  color: #ffffff;\n}\n\n/* -------- Navbar CSS Start -------- */\n\n/* Navbar background */\n/* .orange-block {\n  background-color: #ec4d13;\n  height: 50px;\n} */\n\n/* Navbar container */\n.navbar .container-fluid {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap; /* Prevent wrapping */\n  padding: 0.5rem 1rem;\n}\n\n/* Logo */\n.navbar-brand img {\n  height: 20px; /* Default logo size */\n}\n\n/* Navbar links wrapper */\n.custom-navbar-links {\n  display: flex;\n  flex: 1; /* Allow navbar links to take available space */\n  justify-content: end;\n}\n\n/* Ensure navbar items are in a row */\n.navbar-nav {\n  display: flex !important; /* Ensure Bootstrap does not override */\n  flex-direction: row !important; /* Force horizontal alignment */\n  align-items: center;\n  gap: 20px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Navbar links */\n.navbar-nav .nav-item {\n  display: flex; /* Ensure links don't stack */\n  align-items: center;\n}\n\n/* Navbar link styles */\n.navbar-nav .nav-link {\n  padding: 8px 12px;\n  color: #0f174f;\n  text-decoration: none;\n  font-size: 14px;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n/* Icons inside links */\n.navbar-nav .nav-link i {\n  font-size: 16px;\n}\n\n/* Login button */\n.btn-theme-orange {\n  background-color: #e2520f;\n  border: none;\n  border-radius: 5px;\n  color: white;\n  padding: 8px 14px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n/* Adjustments for small screens */\n@media (max-width: 768px) {\n  .navbar-brand img {\n    height: 15px; /* Smaller logo size for small devices */\n  }\n\n  .btn-theme-orange {\n    font-size: 10px;\n    padding: 6px 10px;\n  }\n\n  .custom-navbar-links {\n    gap: 1px;\n  }\n\n  .navbar-nav {\n    gap: 1px;\n  }\n\n}\n/* -------- Navbar CSS End -------- */\n\n\n\n\n\n\n/* --------FIBRE CSS START-------- */\n\n\n\n.content1 {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: stretch;\n  flex-wrap: nowrap; /* prevent wrapping on larger screens */\n  width: 100%;\n  /* padding: 48px; */\n  padding-bottom: 40px;\n  gap: 10px; /* some spacing between cards */\n  overflow-x: auto; /* fallback scroll if too many cards */\n}\n\n.custom-card {\n  flex: 1; /* allow shrinking */\n  min-width: 220px; /* don’t shrink too small */\n  max-width: 300px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);\n  padding-bottom: 10px;\n  margin: 20px;\n  margin-left: 0px;\n}\n\n/* Mobile view → stack vertically */\n@media (max-width: 568px) {\n  .content1 {\n    flex-direction: column;\n    flex-wrap: nowrap; /* stack, don’t wrap horizontally */\n    align-items: center;\n  }\n\n  .custom-card {\n    width: 100%; /* take most of the screen */\n    max-width: none;\n    align-items: center;\n  }\n}\n\n\n.custom-card-header {\n  background-color: #E2520F;\n  color: white;\n  text-align: center;\n  font-weight: bold;\n  font-size: 1.5rem;\n  padding: 10px;\n  border-radius: 20px 20px 0 0;\n  width: 100%;\n}\n\n.custom-card-body {\n  padding: 15px;\n  text-align: center;\n}\n\n.custom-card-footer {\n  margin-top: auto;\n  display: flex; /* Enable Flexbox */\n  justify-content: center; /* Center horizontally */\n  align-items: center; /* Center vertically (optional) */\n  \n}\n\n.text-orange {\n  color: #E2520F;\n}\n\n.btn-orange {\n  background-color: #E2520F;\n  color: #ffffff;\n  border: none;\n  border-radius: 35px;\n  padding: 10px 50px;\n  font-size: 0.7rem;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  width: 100%;\n  margin: 0 auto;\n  display: block;\n}\n\n.btn-orange:hover {\n  background-color: #0f174f;\n}\n/* --------FIBRE CSS END-------- */\n\n\n\n\n\n/*----------RFC CSS START----------- */\n\n.btn-custom {\n  background-color: #131d72;\n  color: #ffffff;\n  border: none;\n  border-radius: 35px;\n  padding: 10px 20px;\n  font-size: 1rem;\n  font-weight: bold;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  height: 45px;\n  width: 177px;\n}\n\n.btn-custom:hover {\n  background-color: #0f174f; /* Slightly darker shade on hover */\n  transform: scale(1.05); /* Zoom effect */\n}\n\n/* ----------RFC CSS END------------- */\n\n\n\n\n\n\n\n\n/* -------- ABOUT US CSS START -------- */\n.container {\n  max-width: 1200px;\n  margin: auto; /* Center the container */\n}\n\nh2 {\n  font-size: 2rem; /* Increase the font size */\n  margin-bottom: 2rem;\n  color: rgb(23 37 84); /* Apply text-blue-950 color */\n  text-transform: uppercase; /* Optional: Makes text uppercase */\n  text-align: center; /* Center align */\n}\n\nh4 {\n  font-size: 1.5rem; /* Increase the font size */\n  font-weight: bold;\n  color: rgb(23 37 84); /* Apply text-blue-950 color */\n  margin: 12px 25px\n}\n\np2 {\n  font-size: 1.125rem; /* Increase the font size */\n  line-height: 1.8; /* Adjust line spacing */\n  color: #000; /* Light gray color */\n  font-weight: 500;\n  margin: 12px 125px\n}\n\n/* Add optional padding for better spacing */\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n\n.about-block {\n  background-color: #ffffff; /* White background */\n  border-radius: 8px; /* Rounded corners */\n  padding: 20px;/* Padding inside the block */\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  transition: box-shadow 0.3s ease, transform 0.3s ease; /* Smooth hover effect */\n  margin: 40px;\n}\n\n/* Hover effect */\n.about-block:hover {\n  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.2); /* Stronger shadow on hover */\n  transform: translateY(-5px); /* Slight upward movement */\n}\n\n/* Paragraph styling */\n.about-block p {\n  color: rgb(23, 37, 84); /* Text color */\n  font-size: 1rem; /* Font size */\n  line-height: 1.5; /* Line height for readability */\n}\n\n\n/* -------- ABOUT US CSS END ----------- */\n\n\n\n\n\n\n\n/* --------- FOOTER CSS START ----------- */\n\n.footer {\n  background-color: #e65c1c;\n  color: white;\n  text-align: center;\n  padding: 10px 0;\n}\n\n/* Stick Footer to Bottom on Larger Screens */\n@media (min-width: 768px) {\n  .footer {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n  }\n\n  .main-content {\n    padding-bottom: 60px; /* Add space for the footer */\n  }\n}\n\n/* --------- FOOTER CSS END ------------ */\n\n\n\n\n\n\n\n\n\n\n/*------ APPLICATION FORM CSS START ------  */\n\n\n#application-form-page {\n  background: #fff;\n  padding: 10px;\n  /* border: 1px solid #ccc;\n  border-radius: 5px; */\n}\n\n#application-form-page label {\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n#application-form-page input,\n#application-form-page textarea,\n#application-form-page select {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  transition: border-color 0.3s ease; /* Smooth transition for border color */\n}\n\n#application-form-page input:focus,\n#application-form-page textarea:focus,\n#application-form-page select:focus,\n#application-form-page input:hover,\n#application-form-page textarea:hover,\n#application-form-page select:hover {\n  border-color: #e56521; /* Orange border on focus and hover */\n  outline: none; /* Remove default outline */\n}\n\n#application-form-page .btn {\n  font-weight: bold;\n  padding: 10px 15px;\n  background-color: #e56521;\n  border: none;\n  color: #ffffff;\n}\n#application-form-page .btn:hover {\n  background-color: #131d72; /* Darker orange on hover */\n}\n\n#application-form-page h2,\n#application-form-page h4 {\n  color: #e56521;\n  font-weight: bold;\n}\n\n#application-form-page .form-section {\n  padding: 15px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  background-color: #fff;\n}\n\n\n\n\n/* ------- APPLICATION FORM CSS END ------- */\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* ------- PROFILE CSS START --------- */\n\n.group {\n  max-width: 1070px;\n  margin: 0 auto;\n  background-color: #fff;\n  border-radius: 2px;\n}\n\n.group,\n.group2 {\n  min-width: 300px;\n  padding: 17px;\n}\n\n.group2 {\n  max-width: 1091px;\n}\n\n/* ------- PROFILE CSS END ---------- */\n\n\n\n/* --------- MANAGE SUBSCRIPTION CSS START */\n\n.btn-action {\n  background-color: #E2520F; /* Orange color */\n  color: #ffffff; /* White text */\n  border: none; /* Remove default border */\n  border-radius: 10px; /* Rounded corners */\n  padding: 10px 20px; /* Padding for the button */\n  font-size: 0.7rem; /* Font size */\n  font-weight: bold; /* Bold text */\n  cursor: pointer; /* Change cursor to pointer on hover */\n  transition: all 0.3s ease; /* Smooth transition for hover effects */\n}\n\n.btn-action:hover {\n  background-color: #152455; /* Darker orange on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow on hover */\n}\n\n/* --------- MANAGE SUBSCRIPTION CSS START */\n\n\n\n\n\n/* --------- MANAGE PACKAGE CSS START */\n\n.container {\n  max-width: 600px;\n  margin: auto;\n}\n\n.card {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n/* .btn-orange {\n  background-color: #E2520F;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px;\n  font-size: 0.9rem;\n  font-weight: bold;\n  transition: all 0.3s ease;\n} */\n\n/* .btn-orange:hover {\n  background-color: #E63900;\n} */\n\n.btn-outline-orange {\n  background-color: transparent;\n  color: #E2520F;\n  border: 2px solid #E2520F;\n  border-radius: 5px;\n  padding: 10px 20px;\n  font-size: 0.9rem;\n  font-weight: bold;\n  transition: all 0.3s ease;\n}\n\n.btn-outline-orange:hover {\n  background-color: #E2520F;\n  color: #fff;\n}\n\n\n/* --------- MANAGE PACKAGE CSS END ----------------*/\n\n\n\n\n\n\n\n/* ------------------- logged in nav -----------------*/\n\n/* Navbar background */\n.loggedin-nav-background {\n  background-color: #e2520f;\n  height: 50px;\n}\n\n/* Navbar container */\n.loggedin-nav-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap; /* Prevent wrapping */\n  padding: 0.5rem 1rem;\n}\n\n/* Logo */\n.loggedin-nav-logo img {\n  height: 20px; /* Default logo size */\n}\n\n/* Navbar links wrapper */\n.loggedin-nav-links {\n  display: flex;\n  flex: 1; /* Allow navbar links to take available space */\n  justify-content: end;\n}\n\n/* Ensure navbar items are in a row */\n.loggedin-nav-items {\n  display: flex;\n  flex-direction: row; /* Horizontal layout for all screen sizes */\n  align-items: center;\n  gap: 20px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Navbar links */\n.loggedin-nav-item {\n  display: flex; /* Ensure links don't stack */\n  align-items: center;\n}\n\n/* Navbar link styles */\n.loggedin-nav-link {\n  padding: 8px 12px;\n  color: #0f174f;\n  text-decoration: none;\n  font-size: 14px;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n/* Icons inside links */\n.loggedin-nav-link i {\n  font-size: 16px;\n}\n\n/* Login button */\n.loggedin-nav-btn {\n  background-color: #e2520f;\n  border: none;\n  border-radius: 5px;\n  color: white;\n  padding: 8px 14px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n/* Adjustments for small screens */\n@media (max-width: 768px) {\n  .loggedin-nav-items {\n    flex-direction: row; /* Keep links horizontal */\n    align-items: center; /* Center links vertically */\n    gap: 10px; /* Add spacing between links */\n  }\n\n  .loggedin-nav-container {\n    flex-direction: row; /* Keep the container horizontal */\n    align-items: center;\n    justify-content: space-between; /* Space out items */\n  }\n\n  .loggedin-nav-links {\n    width: auto; /* Allow links to take their natural width */\n  }\n\n  .loggedin-nav-link {\n    width: auto; /* Ensure links don't stretch */\n    text-align: center; /* Center align text */\n    padding: 8px 12px; /* Adjust padding for smaller screens */\n  }\n}\n\n/* ------------------- logged in nav ----------------*/\n\n\n\n\n\n/* ----------------------- Referral ------------------------ */\n/* =========================\n   REFERRAL PAGE\n========================= */\n/* =========================\n   REFERRAL PAGE\n========================= */\n\n.referral-page {\n  background: #f8fafc;\n  min-height: 100vh;\n}\n\n/* =========================\n   HERO SECTION\n========================= */\n/* =========================\n   REFERRAL PAGE\n========================= */\n\n.referral-page {\n  background: #f8fafc;\n  min-height: 100vh;\n}\n\n/* =========================\n   HERO SECTION\n========================= */\n.referral-hero {\n  /* background image is set inline via style={{ backgroundImage: \"url(/NEW.jpeg)\" }} */\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 0;\n  color: white;\n  text-align: center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n min-height: clamp(290px, 49vw, 959px); \n  width: 100%;\n}\n\n.referral-hero .container {\n  width: 100%;\n  padding: clamp(20px, 6vw, 90px);\n  box-sizing: border-box;\n}\n\n.referral-text-box {\n  background: #ffffff;\n  border-radius: 16px 16px 0 0;\n  padding: clamp(20px, 4vw, 32px) clamp(20px, 5vw, 40px);\n  max-width: 680px;\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.15);\n  box-sizing: border-box;\n}\n\n.referral-title {\n  color: #111111;\n  font-size: clamp(1.25rem, 4vw, 2rem);\n  line-height: 1.2;\n}\n\n.referral-subtitle {\n  color: #444444;\n  opacity: 1;\n  font-size: clamp(0.875rem, 2.5vw, 1.05rem);\n}\n\n/* Tablet */\n@media (max-width: 768px) {\n  .referral-hero {\n   min-height: 0px; \n  }\n\n  .referral-text-box {\n    border-radius: 12px 12px 0 0;\n  }\n}\n\n/* Mobile */\n@media (max-width: 480px) {\n  .referral-hero {\n    min-height: 201px;\n  }\n\n  .referral-hero .container {\n    padding: 16px;\n  }\n\n  .referral-text-box {\n    border-radius: 10px 10px 0 0;\n    box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.15);\n  }\n}\n\n/* Very small screens */\n@media (max-width: 360px) {\n  .referral-hero {\n    min-height: 16px;\n  }\n\n  .referral-text-box {\n    padding: 16px;\n  }\n}\n\n\n/* \n\n\n\n =========================\n   BENEFITS SECTION\n========================= */\n\n.referral-benefits {\n  padding: 70px 20px;\n}\n\n.benefit-card {\n  border: none !important;\n  border-radius: 18px !important;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);\n  transition: all 0.25s ease;\n  overflow: hidden;\n}\n\n.benefit-card:hover {\n  transform: translateY(-6px);\n}\n\n.benefit-card .card-body {\n  padding: 35px 25px;\n  text-align: center;\n}\n\n.benefit-card h4 {\n  color: #0f174f;\n  font-weight: 700;\n  margin-bottom: 14px;\n}\n\n.benefit-card p {\n  color: #6b7280;\n  margin-bottom: 0;\n  line-height: 1.6;\n}\n\n.benefit-icon {\n  width: 70px;\n  height: 70px;\n  border-radius: 16px;\n  background: rgba(226, 82, 15, 0.1);\n  color: #e2520f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px auto;\n  font-size: 2rem;\n}\n\n/* =========================\n   FORM SECTION\n========================= */\n\n.referral-form-section {\n  padding: 90px 20px 90px 20px;\n}\n\n.referral-form-card {\n  border: none !important;\n  border-radius: 22px !important;\n  overflow: hidden;\n  box-shadow: 0 15px 40px rgba(15, 23, 79, 0.08);\n}\n\n.referral-form-card .card-body {\n  padding: 45px;\n}\n\n.rf-card {\n  border: none !important;\n  border-radius: 22px !important;\n  overflow: hidden;\n  box-shadow: 0 15px 40px rgba(15, 23, 79, 0.08);\n  background: #ffffff;\n}\n\n.rf-card .card-body {\n  padding: 45px;\n}\n\n.rf-section {\n  background: #f8fafc;\n  border: 1px solid #edf1f6;\n  border-radius: 18px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.rf-section-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.rf-label-plain,\n.rf-step-title {\n  font-size: 0.76rem;\n  letter-spacing: 0.08em;\n  font-weight: 800;\n  color: #0f174f;\n}\n\n.rf-step-num {\n  width: 30px;\n  height: 30px;\n  border-radius: 10px;\n  background: #e2520f;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.rf-section-line {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(90deg, rgba(226, 82, 15, 0.35), rgba(226, 82, 15, 0.05));\n}\n\n.rf-section-end-icon {\n  color: #e2520f;\n  font-size: 1rem;\n}\n\n.rf-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.rf-grid-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.rf-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.rf-field-full {\n  grid-column: 1 / -1;\n}\n\n.rf-field-label {\n  font-size: 0.72rem;\n  letter-spacing: 0.06em;\n  font-weight: 700;\n  color: #374151;\n}\n\n.rf-input-wrap {\n  position: relative;\n}\n\n.rf-input-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 1rem;\n}\n\n.rf-input {\n  width: 100%;\n  min-height: 52px;\n  border-radius: 14px;\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  padding: 0.9rem 1rem 0.9rem 2.75rem;\n  color: #111827;\n  font-size: 0.98rem;\n  transition: all 0.2s ease;\n}\n\n.rf-input::placeholder {\n  color: #9ca3af;\n}\n\n.rf-input:focus {\n  border-color: #e2520f !important;\n  box-shadow: 0 0 0 0.2rem rgba(226, 82, 15, 0.15) !important;\n  outline: none;\n}\n\n.rf-input-readonly {\n  background: #f3f4f6;\n  color: #374151;\n  cursor: default;\n}\n\n.rf-credit-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba(226, 82, 15, 0.12);\n  background: rgba(226, 82, 15, 0.04);\n  color: #4b5563;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.rf-credit-note i {\n  color: #e2520f;\n  margin-top: 0.15rem;\n}\n\n.rf-credit-note a,\n.rf-reward-note a {\n  color: #e2520f;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.rf-consent {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  padding: 1rem 1.1rem;\n  border-radius: 14px;\n  border: 1px solid #edf1f6;\n  background: #f8fafc;\n  color: #374151;\n  line-height: 1.5;\n}\n\n.rf-consent input {\n  margin-top: 0.2rem;\n  width: 1.05rem;\n  height: 1.05rem;\n  accent-color: #e2520f;\n}\n\n.rf-footer {\n  margin-top: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.rf-reward-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  color: #4b5563;\n  line-height: 1.5;\n  font-size: 0.95rem;\n}\n\n.rf-reward-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  background: rgba(226, 82, 15, 0.12);\n  color: #e2520f;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.rf-submit-btn {\n  background: #e2520f !important;\n  border: none !important;\n  border-radius: 12px !important;\n  padding: 0.95rem 2rem !important;\n  color: #ffffff !important;\n  font-weight: 700 !important;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  box-shadow: 0 10px 20px rgba(226, 82, 15, 0.2);\n  transition: all 0.25s ease;\n}\n\n.rf-submit-btn:hover {\n  background: #c9470d !important;\n  transform: translateY(-1px);\n}\n\n.rf-submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.rf-submit-icon {\n  font-size: 1rem;\n}\n\n.rf-locked-card {\n  background: #ffffff;\n}\n\n.rf-locked-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 50px 2rem !important;\n}\n\n.rf-locked-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 18px;\n  background: rgba(226, 82, 15, 0.1);\n  color: #e2520f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  margin-bottom: 1.1rem;\n}\n\n.rf-locked-text {\n  max-width: 540px;\n  color: #6b7280;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n}\n\n.rf-success-modal-body {\n  text-align: center;\n  padding: 2rem 1.5rem;\n}\n\n.rf-success-icon {\n  font-size: 3rem;\n  color: #2f9e44;\n  margin-bottom: 0.75rem;\n}\n\n.rf-success-title {\n  color: #0f174f;\n  font-weight: 800;\n  margin-bottom: 0.5rem;\n}\n\n.rf-success-text {\n  color: #4b5563;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.rf-success-code {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding: 1rem;\n  border-radius: 16px;\n  border: 1px solid rgba(226, 82, 15, 0.15);\n  background: rgba(226, 82, 15, 0.03);\n}\n\n.rf-success-code-label {\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  font-weight: 700;\n  color: #6b7280;\n}\n\n.rf-success-code-value {\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: #e2520f;\n}\n\n.form-title {\n  text-align: center;\n  color: #0f174f;\n  font-weight: 800;\n  margin-bottom: 35px;\n}\n\n.section-title {\n  color: #e2520f;\n  font-weight: 700;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid rgba(226, 82, 15, 0.1);\n}\n\n/* =========================\n   FORM INPUTS\n========================= */\n\n.form-label {\n  font-weight: 600;\n  color: #374151;\n}\n\n.form-control,\n.form-select {\n  border-radius: 12px !important;\n  min-height: 50px;\n  border: 1px solid #d1d5db !important;\n  transition: all 0.2s ease;\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: #e2520f !important;\n  box-shadow: 0 0 0 0.2rem rgba(226, 82, 15, 0.15) !important;\n}\n\n/* =========================\n   CHECKBOX\n========================= */\n\n.form-check-input:checked {\n  background-color: #e2520f !important;\n  border-color: #e2520f !important;\n}\n\n.form-check-label {\n  color: #4b5563;\n  line-height: 1.5;\n}\n\n/* =========================\n   SUBMIT BUTTON\n========================= */\n\n.submit-referral-btn {\n  background: #e2520f !important;\n  border: none !important;\n  padding: 14px 40px !important;\n  border-radius: 12px !important;\n  font-weight: 700 !important;\n  font-size: 1rem !important;\n  transition: all 0.25s ease;\n  min-width: 240px;\n}\n\n.submit-referral-btn:hover {\n  background: #c9470d !important;\n  transform: translateY(-2px);\n}\n\n.submit-referral-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* =========================\n   ALERT\n========================= */\n\n.alert-success {\n  border-radius: 14px !important;\n  border: none !important;\n  background: rgba(34, 197, 94, 0.12) !important;\n  color: #15803d !important;\n  font-weight: 600;\n  padding: 16px 20px !important;\n}\n\n/* =========================\n   RESPONSIVE\n========================= */\n\n@media (max-width: 768px) {\n  .referral-hero {\n    padding: 80px 20px;\n  }\n\n  .referral-form-card .card-body {\n    padding: 28px 20px;\n  }\n\n  .referral-title {\n    font-size: 2.2rem;\n  }\n\n  .submit-referral-btn {\n    width: 100%;\n  }\n\n  .benefit-card .card-body {\n    padding: 28px 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .referral-subtitle {\n    font-size: 1rem;\n  }\n\n  .form-title {\n    font-size: 1.6rem;\n  }\n\n  .section-title {\n    font-size: 1.1rem;\n  }\n}\n\n\n\n\n\n\n\n\n\n/* ===================================================================\n   Referral Form — colors & type sizes matched to the approved mockup\n   =================================================================== */\n\n:root {\n  --rf-navy: #0a1a3c;\n  --rf-orange: #e65c1c;\n  --rf-orange-bg: #fdf0e6;\n  --rf-orange-border: #f5cca3;\n  --rf-orange-text: #8a4a1f;\n  --rf-green: #2e8b3d;\n  --rf-green-bg: #e8f6ea;\n  --rf-green-text: #1f6b34;\n  --rf-gray-label: #6b7280;\n  --rf-gray-input-bg: #f3f4f6;\n  --rf-gray-border: #d9dce1;\n  --rf-gray-icon: #9aa1ab;\n  --rf-text: #374151;\n  --rf-page-bg: #f5f6f8;\n}\n\n.referral-page {\n  background: var(--rf-page-bg);\n}\n\n/* ---------- form card ---------- */\n\n.referral-form-section {\n  padding: 40px 0;\n}\n\n.rf-card {\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(10, 26, 60, 0.06);\n  padding: 12px;\n  margin-bottom: 18%;\n}\n\n.form-title {\n  color: var(--rf-navy);\n  font-weight: 800;\n  font-size: 26px;\n  text-align: center;\n  letter-spacing: 0.5px;\n  margin-bottom: 28px;\n}\n\n/* ---------- section headers ---------- */\n\n.rf-section {\n  margin-bottom: 20px;\n}\n\n.rf-section-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.rf-label-plain {\n  color: var(--rf-navy);\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.rf-step-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--rf-orange);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.rf-step-title {\n  color: var(--rf-navy);\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.rf-section-line {\n  flex: 1;\n  height: 1px;\n  background: var(--rf-orange-border);\n}\n\n.rf-section-end-icon {\n  color: var(--rf-orange);\n  font-size: 14px;\n}\n\n/* ---------- fields ---------- */\n\n.rf-grid {\n  display: grid;\n  gap: 16px;\n}\n\n.rf-grid-2 {\n  grid-template-columns: 1fr 1fr;\n}\n\n.rf-field-full {\n  grid-column: 1 / -1;\n}\n\n.rf-field-label {\n  display: block;\n  color: var(--rf-gray-label);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.rf-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.rf-input-icon {\n  position: absolute;\n  left: 12px;\n  color: var(--rf-gray-icon);\n  font-size: 14px;\n  pointer-events: none;\n}\n\n.rf-input {\n  width: 100%;\n  height: 42px;\n  padding: 0 14px 0 36px;\n  font-size: 14px;\n  color: var(--rf-text);\n  background: #fff;\n  border: 1px solid var(--rf-gray-border);\n  border-radius: 8px;\n  outline: none;\n  transition: border-color 0.15s ease;\n}\n\n.rf-input::placeholder {\n  color: #a3a9b3;\n}\n\n.rf-input:focus {\n  border-color: var(--rf-orange);\n}\n\n.rf-input-readonly {\n  background: var(--rf-gray-input-bg);\n  color: #4b5563;\n  cursor: default;\n}\n\n/* ---------- note boxes ---------- */\n\n.rf-credit-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: var(--rf-orange-bg);\n  border: 1px solid var(--rf-orange-border);\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--rf-orange-text);\n}\n\n.rf-credit-note i {\n  color: var(--rf-orange);\n  font-size: 14px;\n  margin-top: 2px;\n}\n\n.rf-credit-note a {\n  color: var(--rf-orange);\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n/* ---------- consent ---------- */\n\n.rf-consent {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--rf-text);\n  cursor: pointer;\n}\n\n.rf-consent input[type=\"checkbox\"] {\n  margin-top: 2px;\n  width: 15px;\n  height: 15px;\n  accent-color: var(--rf-orange);\n}\n\n/* ---------- footer ---------- */\n\n.rf-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 24px;\n  flex-wrap: wrap;\n}\n\n.rf-reward-note {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--rf-green-bg);\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--rf-green-text);\n  flex: 1;\n  min-width: 260px;\n}\n\n.rf-reward-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--rf-green);\n  color: #fff;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.rf-reward-note a {\n  color: var(--rf-green-text);\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.rf-submit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--rf-orange);\n  border: none;\n  color: #fff;\n  font-weight: 700;\n  font-size: 13.5px;\n  letter-spacing: 0.4px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  white-space: nowrap;\n  transition: background 0.15s ease;\n}\n\n.rf-submit-btn:hover {\n  background: #cf4f14;\n}\n\n.rf-submit-btn:disabled {\n  background: #f0a878;\n  cursor: not-allowed;\n}\n\n.rf-submit-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.25);\n  font-size: 11px;\n}\n\n/* ---------- success modal ---------- */\n\n.rf-success-modal-body {\n  text-align: center;\n  padding: 32px 24px;\n}\n\n.rf-success-icon {\n  color: #2f9e44;\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n\n.rf-success-title {\n  color: var(--rf-orange);\n  font-weight: 800;\n  font-size: 20px;\n  margin-bottom: 8px;\n}\n\n.rf-success-text {\n  color: var(--rf-text);\n  font-size: 13.5px;\n  margin-bottom: 16px;\n}\n\n.rf-success-code {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background: var(--rf-gray-input-bg);\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 20px;\n}\n\n.rf-success-code-label {\n  color: var(--rf-gray-label);\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.rf-success-code-value {\n  color: var(--rf-navy);\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 1px;\n}\n\n/* !important here overrides react-bootstrap's default .btn-primary\n   (blue) classes that ship alongside this custom class on <Button>. */\n.rf-success-close-btn {\n  background: var(--rf-orange) !important;\n  border-color: var(--rf-orange) !important;\n  color: #fff !important;\n  font-weight: 700;\n  font-size: 13.5px;\n  padding: 10px 28px;\n  border-radius: 8px;\n  box-shadow: none !important;\n}\n\n.rf-success-close-btn:hover,\n.rf-success-close-btn:focus,\n.rf-success-close-btn:active {\n  background: #cf4f14 !important;\n  border-color: #cf4f14 !important;\n}\n\n/* ---------- responsive ---------- */\n\n@media (max-width: 576px) {\n  .rf-grid-2 {\n    grid-template-columns: 1fr;\n  }\n  .rf-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .rf-submit-btn {\n    justify-content: center;\n  }\n}\n\n.modal-header{\n  background-color: #e2520f;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
